// @avantia common-code
import { lodash } from '@avantia/lodash';

export interface HpClearAndAllHashRecord {
  all?: null;
  clear?: null;
}

export type HpAllHashParams = HpClearAndAllHashRecord;

export const clearAndAllHashRecordKeys: (keyof HpClearAndAllHashRecord)[] = ['clear', 'all'];

export const customerDetailsKeyName = 'customerDetailsKey';
export const mockDataModeHashName = 'mockDataMode';

export const allHashKeys: (keyof HpAllHashParams)[] = lodash.uniq([...clearAndAllHashRecordKeys]).sort();
